import { render } from "./About.vue?vue&type=template&id=1ae8a7be"
const script = {}

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__